import useConversation from "./useConversation";


export default function useMessageHistory(conversationId) {
    const {list, loading} = useConversation()
    const conversation = list?.find(el => el?.id === conversationId);
    const readTimeLine = conversation?.readTimeLine || []
    const receivedTimeLine =conversation?.receivedTimeLine || []
    return {list: readTimeLine,receivedTimeLine, loading};
}